module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('strong', [_c('em', [_vm._v("Contents")])])])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/007_Acknowledgments#fm-1"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Preface#fm-2"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/009_FamilyTree#fm-3"
    }
  }, [_c('em', [_vm._v("Family Tree")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Part01#pt-1"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PART I")])]), _c('br'), _c('strong', [_c('em', [_vm._v("From Vienna to Amsterdam")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#ch-1"
    }
  }, [_vm._v("Refugees")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter02#ch-2"
    }
  }, [_vm._v("Amsterdam")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Hiding")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prison")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part02#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PART II")])]), _c('br'), _c('strong', [_c('em', [_vm._v("Auschwitz-Birkenau")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deported")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Birkenau")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Minni")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Canada”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reunion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/022_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter12#ch-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pappy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter13#ch-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mutti’s Story")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter14#ch-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mutti")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter15#ch-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Liberation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Part03#pt-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PART III")])]), _c('br'), _c('strong', [_c('em', [_vm._v("Journey through Russia")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Map#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map of Journey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter16#ch-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Russians")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/030_Chapter17#ch-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outside the Gate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/031_Chapter18#ch-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Road to Auschwitz")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/032_Chapter19#ch-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Auschwitz")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/033_Chapter20#ch-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Katowice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/034_Chapter21#ch-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Czernowitz")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/035_Chapter22#ch-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mutti’s Journey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/036_Chapter23#ch-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Odessa")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/037_Chapter24#ch-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Repatriation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/038_Chapter25#ch-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holland")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm1"
  }, [_c('span', {
    attrs: {
      "href": "#/039_Epilogue#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/040_Postscript#bm-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Postscript by Fritzi Frank")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/041_MyStory#bm-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“My Story Is the Story of Anne Frank after Her "), _c('em', [_vm._v("Diary")]), _vm._v(" Ends,” "), _c('em', [_vm._v("An Interview with Eva Schloss")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/042_Discussion#bm-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/043_Recommended#bm-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recommended Resources")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42bd9c78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Contents.vue
// module id = 72
// module chunks = 0